import PropTypes from 'prop-types';

export const CapEditTextFieldPropTypes = {
  action: PropTypes.object,
  editable: PropTypes.bool,
  forTitle: PropTypes.bool,
  isRequired: PropTypes.bool,
  onSave: PropTypes.func,
  reviewNotes: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.string,
};

export const CapEditTextFieldDefaultProps = {
  value: '',
};
